/* import __COLOCATED_TEMPLATE__ from './market-field-select.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
/**
### Parameters
@param {Array} [content=[]] - Can take an array of Strings, Numbers or Objects. The items of the array will be used as both the value property and the inner text of each <option> element inside the rendered `sq-field-select`. When using objects you need to state (using `optionGroupPath`, `optionLabelPath` and `optionValuePath`) which property should be accessed on each object to supply the value attribute of the <option> and which property should be used to supply the element text.
@param {Boolean} [disabled=false] - Set to `true` to disable the field select.
@param {Boolean} [enablePromptSelection=false] - Set to `true` to enables a prompt for the select.
@param {String} [optionLabelPath="label"] - Specifies the path on each object to the desired property for the element's text.
@param {String} [optionSubtextPath="subtext"] - Used to specify the path on each object to the desired property for the `subtext` attribute.
@param {String} [optionValuePath="value"] - Used to specify the path on each object to the desired property for the `value` attribute.
@param {Boolean} [useOptionsAsValues=false] - Enable to select the entire object as `value` when selecting instead of using `optionValuePath`.
@param {Boolean} [readonly=false] - whether this component is readonly.
@param {String} [value=null] - The selected option.
@param {String} [label=null] - The option select label.
@param {Function} onChange - Action to call when the selected option changes. Will receive the new selected option with the properties label and value.
 */

import { set, action, computed } from '@ember/object';
import { isArray } from '@ember/array';
import Component from '@ember/component';
import { next } from '@ember/runloop';
let MarketFieldSelect = (_dec = computed('content.[]'), _class = class MarketFieldSelect extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "content", null);
    _defineProperty(this, "label", null);
    _defineProperty(this, "optionValuePath", 'value');
    _defineProperty(this, "optionLabelPath", 'label');
    _defineProperty(this, "optionSubtextPath", 'subtext');
    _defineProperty(this, "optionDisabledPath", 'disabled');
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "useOptionsAsValues", false);
    _defineProperty(this, "enablePromptSelection", false);
    _defineProperty(this, "value", null);
    _defineProperty(this, "prompt", null);
    _defineProperty(this, "isInvalid", false);
    _defineProperty(this, "readonly", false);
    _defineProperty(this, "selectedValue", undefined);
    _defineProperty(this, "selectPaddingBuffer", 0);
  }
  didRender(...args) {
    super.didRender(...args);
    // market-select no longer supports setting a value before the underlying market-list is defined.
    // Once content is set, we can set the value on the next render as the market-list will be rendered.
    if (this.content) {
      next(() => {
        if (this.isDestroyed || this.isDestroying) {
          return;
        }
        set(this, 'selectedValue', this.value || this.prompt || undefined);
      });
    } else {
      set(this, 'selectedValue', this.prompt || undefined);
    }
  }
  get optionsAreStringsOrNumbers() {
    const options = this.content;
    return isArray(options) && options.every(option => {
      return typeof option === 'string' || typeof option === 'number';
    });
  }
  change(newSelectedOption) {
    if (this.isDestroyed) {
      return;
    }
    const selectValue = newSelectedOption.value;
    const selectedOption = this.optionValuePath ? this.content.find(object => {
      return object[this.optionValuePath] === selectValue;
    }) : selectValue;
    set(this, 'value', selectValue);
    this.onChange?.(selectedOption);
  }
}, _applyDecoratedDescriptor(_class.prototype, "optionsAreStringsOrNumbers", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "optionsAreStringsOrNumbers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "change", [action], Object.getOwnPropertyDescriptor(_class.prototype, "change"), _class.prototype), _class);
export { MarketFieldSelect as default };